import { jsx } from 'react/jsx-runtime';

// eslint-disable-next-line import/no-default-export -- Icon
function Bolt({ className, "data-testid": testId, }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "16", preserveAspectRatio: "xMidYMid meet", className: className, "data-testid": testId, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", stroke: "null", d: "M6.54664 0.412598L0 11.2753H5.12346L3.70027 19.1986L10.2469 8.33589H5.12346L6.54664 0.412598Z", fill: "#219653" }) }));
}

export { Bolt as default };
//# sourceMappingURL=Bolt.js.map
